import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AiPlannerIframeModalEntrypointProps } from './AiPlannerIframeModal.entrypoint.types.tsx';

type AiPlannerIframeModalEntryPointComponent = EntryPointComponent<
	{},
	{},
	AiPlannerIframeModalEntrypointProps,
	{}
>;

export const aiPlannerIframeModalEntryPoint: EntryPoint<
	AiPlannerIframeModalEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AiPlannerIframeModalEntryPointComponent>(
		/* webpackChunkName: "async-ai-planner-iframe-modal" */ './AiPlannerIframeModal.tsx',
	),
	getPreloadProps: () => ({}),
});
